import { SUPPORT_PHONE_NUMBER } from '@common/constants'
import BuiltInIndia from '@components/atoms/built-in-india'
import { currentYear } from '@lib/utils/date.utils'
import { Mail, Phone } from 'react-feather'

const Footer = () => (
  <div className="flex flex-col px-5 py-10 footer-primary-gradient">
    <div className="container max-w-5xl mx-auto">
      <div className="flex flex-col items-center">
        <div className="flex flex-col justify-between w-full lg:flex-row">
          <div className="flex flex-col text-3xl text-white font-600">
            <p>Got questions?</p>
            <p>Contact us anytime.</p>
          </div>
          <div className="flex flex-col px-12 py-6 mt-10 space-y-5 bg-white rounded-lg shadow lg:flex-row lg:justify-between lg:space-x-12 lg:space-y-0 lg:mt-0">
            <div className="flex flex-col">
              <p className="ml-6 text-sm text-grey-700">Send us a message</p>
              <div className="flex items-center">
                <span className="flex items-center justify-center w-5 h-5 rounded-full bg-grey-200">
                  <Mail className="text-orange" size={16} />
                </span>
                <a
                  className="ml-1 text-xl text-orange"
                  href="mailto:support@codingal.com"
                >
                  support@codingal.com
                </a>
              </div>
            </div>
            <div className="flex flex-col">
              <p className="ml-6 text-sm text-grey-700">Call us</p>
              <div className="flex items-center">
                <span className="flex items-center justify-center w-5 h-5 rounded-full bg-grey-200">
                  <Phone className="text-orange" size={16} />
                </span>
                <a
                  className="ml-1 text-xl text-orange"
                  href={`tel:${SUPPORT_PHONE_NUMBER.value}`}
                >
                  {SUPPORT_PHONE_NUMBER.label}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className="my-10 text-white" />
      <div className="flex flex-col mt-10 mb-20 space-y-10 lg:flex-row lg:space-x-16 lg:space-y-0">
        <div className="flex flex-col flex-1">
          <div className="flex items-center">
            <span className="text-xl text-white font-600">
              Our mission and vision
            </span>
          </div>
          <p className="mt-5 text-white">
            Codingal is on a mission to inspire school kids and teens to fall in
            love with coding. Coding is proven to develop creativity, logical
            thinking and problem solving skills in kids. Coding is an essential
            skill of the future and more than 60% of all jobs in STEM-related
            fields require knowledge of code. Kids who start learning to code at
            a young age are guaranteed to become leaders, creators and
            entrepreneurs of the future.
          </p>
        </div>
      </div>
      <div className="flex justify-center md:justify-end">
        <span className="text-white">
          ©️ {currentYear} Codingal. <BuiltInIndia />
        </span>
      </div>
    </div>
  </div>
)

export default Footer
